// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
// Bootstrap
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap
document.addEventListener("turbo:load", () => {
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))
})
// PlatformHelper
import * as PlatformHelpers from "./src/platform_helpers"
console.log(PlatformHelpers.isMobile)